<div class="talent-page-wrapper">
    <!-- Header -->
    <header class="talent-header">
        <div class="logo-section">
            <ng-container *ngIf="logoUrl; else defaultLogo">
                <img [src]="logoUrl" alt="Company Logo"
                    style="max-height: 40px; max-width: 150px; object-fit: contain; margin-right: 10px;">
            </ng-container>
            <ng-template #defaultLogo>
                <div class="logo-icon">
                    <i class="bi bi-cpu-fill"></i>
                </div>
            </ng-template>
            <div class="logo-text">
                <h6>{{ organizationName || 'AI Interview Platform' }}</h6>
            </div>
        </div>
        <div class="secure-badge">
            <span class="dot"></span>
            Secure AI session
        </div>
    </header>

    <div class="verification-page-wrapper">
        <div class="verification-card">
            <!-- Card Header -->
            <div class="card-header">
                <div class="shield-icon-wrapper">
                    <i class="bi bi-file-earmark-person"></i>
                </div>
                <h2>Upload Resume</h2>
                <p>Please upload your resume to continue to the interview session.</p>
            </div>

            <div class="step-container">
                <div class="input-wrapper">
                    <label class="form-label">Resume (PDF, DOC, DOCX)</label>
                    <input type="file" class="form-control" (change)="onFileSelected($event)"
                        accept=".pdf,.doc,.docx" />
                </div>

                <div *ngIf="selectedFile" class="selected-file-info">
                    <i class="bi bi-file-earmark-text"></i>
                    <span>{{ selectedFile.name }}</span>
                </div>

                <div class="mt-4">
                    <button type="button" class="submit-btn" [disabled]="!selectedFile || isLoading"
                        (click)="continueToInterview()">
                        <span>{{ isLoading ? 'Uploading...' : 'Upload & Continue' }}</span>
                        <i class="bi bi-arrow-right" *ngIf="!isLoading"></i>
                    </button>


                </div>
            </div>

            <!-- <div class="footer-text">
                By continuing you agree to our <a href="#">terms</a> and <a href="#">privacy policy</a>.
            </div> -->
        </div>
    </div>
</div>

<!-- Premium Loader -->
<div *ngIf="isLoading" class="premium-loader-overlay">
    <div class="premium-spinner">
        <div class="spinner-ring"></div>
        <i class="bi bi-cpu-fill spinner-icon"></i>
    </div>
</div>

<!-- Premium Language Selection Modal Overlay -->
<div *ngIf="showLanguageModal" class="premium-modal-overlay">
  <div class="premium-modal-container">
    <!-- Modal Header -->
    <div class="premium-modal-header">
      <div class="language-icon-wrapper">
        <i class="bi bi-translate"></i>
      </div>
      <h2>Choose Your Interview Language</h2>
      <p>Select the language in which you would like to interact with the AI interviewer. The AI will communicate with you in the chosen language.</p>
    </div>

    <!-- Modal Body: Language Grid -->
    <div class="language-options-grid">
      <div *ngFor="let lang of languages" 
           class="language-option-card"
           [class.active]="selectedLanguage === lang.code"
           (click)="selectLanguage(lang.code)">
        <div class="language-info">
          <span class="native-name">{{ lang.native_name || lang.name }}</span>
          <span class="english-name">{{ lang.name }}{{ lang.code === 'en' ? ' (Default)' : '' }}</span>
        </div>
        <div class="selection-indicator">
          <i class="bi bi-check-circle-fill" *ngIf="selectedLanguage === lang.code"></i>
          <span class="unselected-dot" *ngIf="selectedLanguage !== lang.code"></span>
        </div>
      </div>
    </div>

    <!-- Alert Banner -->
    <div class="info-alert-banner">
      <i class="bi bi-info-circle-fill"></i>
      <p>Your interview will be conducted in the selected language. Once the interview begins, the language cannot be changed.</p>
    </div>

    <!-- Modal Actions -->
    <div class="premium-modal-actions">
      <button type="button" class="submit-btn" (click)="confirmLanguageSelection()">
        <span>Continue to Interview</span>
        <i class="bi bi-arrow-right"></i>
      </button>
    </div>
  </div>
</div>